import StudioTabs from './StudioTabsContainer';
export default StudioTabs;
